import {useMutation} from '@apollo/client/react';
import {Job} from '@cp/model';
import {CREATE_QUESTION_SHUFFLE_JOB} from '../sharedQueries';

/**
 * Hook for creating question shuffle jobs
 * This will create a background job to shuffle questions for specified topics and difficulties
 */
export function useCreateQuestionShuffleJob() {
  const [createQuestionShuffleJobMutation, {loading, error}] = useMutation<
    {createQuestionShuffleJob: Job},
    {moduleId: string; topics?: string[]; difficulties?: number[]}
  >(CREATE_QUESTION_SHUFFLE_JOB);

  const createQuestionShuffleJob = async (moduleId: string, topics?: string[], difficulties?: number[]) => {
    try {
      const result = await createQuestionShuffleJobMutation({
        variables: {moduleId, topics, difficulties},
      });

      return result.data?.createQuestionShuffleJob;
    } catch (err) {
      console.error('Error creating question shuffle job:', err);
      throw err;
    }
  };

  return {
    createQuestionShuffleJob,
    loading,
    error,
  };
}
